
import React from 'react';

interface EmptyInterviewsListProps {
  message?: string;
}

const EmptyInterviewsList: React.FC<EmptyInterviewsListProps> = ({ 
  message = "Ingen ventende intervjuer funnet. Intervjuer vil vises her når de er sendt inn."
}) => {
  return (
    <div className="bg-white rounded-lg shadow p-8 text-center">
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="rounded-full bg-gray-100 p-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-10 w-10 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M8 12h.01M12 12h.01M16 12h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-gray-900">Ingen Intervjuer</h3>
        <p className="text-gray-600 max-w-md">
          {message}
        </p>
      </div>
    </div>
  );
};

export default EmptyInterviewsList;
